import { useState, useMemo } from 'react'

import useFetch from '../../hooks/useFetch'
import { getDeveloperAPIKeys, deleteApiKeys } from '../../api-client/data'
import Button from '../nura/button/button'

import styles from './styles.module.css'

import { DashboardBody, DashboardHeader } from '../dashboard-container'
import CreateApiKey from '../dialogs/create-api-key'
import RequestTable from '../request-table/generic'
import DeleteApiKey from '../dialogs/delete-api-key'
import { useSnackbar } from '../snackbar/snackbar'

const ApiKeys = () => {
    const apiKeys = useFetch(getDeveloperAPIKeys, undefined)
    const [showCreateAPIKey, setShowCreateAPIKey] = useState(false)
    const [deleteApiKey, setDeleteApiKey] = useState(false)
    const [selectedItems, setSelectedItems] = useState([])
    const [loading, setLoading] = useState(false)

    const { enqueueSnackbar } = useSnackbar()

    const deleteSelectedItems = async () => {
        setDeleteApiKey(false)

        setLoading(true)
        try {
            await deleteApiKeys(selectedItems)

            enqueueSnackbar("Deleted successfully", {
                variant: "success"
            })
        } catch {
            enqueueSnackbar("Could not delete all of the items", {
                variant: "error"
            })
        }
        setLoading(false)

        apiKeys.refresh()
    }

    const orderedData = useMemo(() => apiKeys?.data?.map(x => ({
        _id: x?.id,
        Name: x?.name,
        Key: x?.apiKey,
        LastUsed: x?.lastUsed,
        CreatedAt: x?.createdAt,
    })), [apiKeys?.data])

    const onClose = () => {
        setShowCreateAPIKey(false)
        apiKeys.refresh()
    }

    return (
        <div className={styles.dashboardContent}>
            <CreateApiKey
                show={showCreateAPIKey}
                setShow={setShowCreateAPIKey}
                onClose={onClose}
            />
            <DeleteApiKey
                show={deleteApiKey}
                setShow={setDeleteApiKey}
                handleDelete={deleteSelectedItems}
            />
            <DashboardHeader title="Api Keys">
                <div style={{ display: 'flex', gap: 20 }}>
                    <Button size="normal" variant="error" disabled={selectedItems?.length === 0} loading={loading} onClick={()=>setDeleteApiKey(true)}>Delete</Button>
                    <Button size="normal" variant="fancy" loading={loading} onClick={() => setShowCreateAPIKey(true)}>Create New Key</Button>
                </div>
            </DashboardHeader>
            <DashboardBody variant="nopad" loading={apiKeys?.loading}>
                <RequestTable setChecked={setSelectedItems} data={orderedData} />
            </DashboardBody>
        </div>
    )
}

export default ApiKeys
